import React from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import Selectsearch from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';

import {
	FormGroup,
	Label,
	
} from 'reactstrap';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import { 
    allStudents,
    editFSIrons,
 } from 'Actions';

class EditItems extends React.Component {
  
    static propTypes = {
        classes: PropTypes.object,
        prev:0,
    };

    UNSAFE_componentWillMount() {
        this.props.allStudents();
	}
    constructor(props) {
      
        super(props);
        this.state = {  
            seldate:new Date(this.props.data.seldate), 
            student:this.props.data.student, 
            eid:this.props.data.eid, 
            clubform:this.props.data.clubform, 
            cntclub:this.props.data.cntclub,
            ballform:this.props.data.ballform,
            cntball:this.props.data.cntball,
            rateform:this.props.data.rateform,
            cntrate:this.props.data.cntrate,
            smashform:this.props.data.smashform,
            cntsmash:this.props.data.cntsmash,            
            carryform:this.props.data.carryform,
            cntcry:this.props.data.cntcry,
            aoaform:this.props.data.aoaform,
            cntaoa:this.props.data.cntaoa,
            pathform:this.props.data.pathform,
            cntpath:this.props.data.cntpath,
            hspform:this.props.data.hspform,
            cnthsp:this.props.data.cnthsp,
            ftpform:this.props.data.ftpform,
            cntftp:this.props.data.cntftp,
            fttform:this.props.data.fttform,
            cntftt:this.props.data.cntftt,
        };
    }

    selstudent = (evt) =>{
        var stdid =evt.value;
        this.setState({ student:stdid });
    }


    selectdate = (date) => {
        const seldate =moment(new Date(date)).format('yyyy-MM-DD');
        this.setState({ seldate:date });
        
    }    

    editHandleSubmit(event){
        event.preventDefault();
        var eid=this.state.eid;
        let cntclub=this.state.cntclub;
        let cntball=this.state.cntball;
        let cntrate=this.state.cntrate;
        let cntsmash=this.state.cntsmash;
        let cntcry=this.state.cntcry;
        let cntaoa=this.state.cntaoa;
        let cntpath=this.state.cntpath;
        let cnthsp=this.state.cnthsp;
        let cntftp=this.state.cntftp;
        let cntftt=this.state.cntftt;
        this.props.editFSIrons(event, eid, cntclub, cntball, cntrate, cntsmash, cntcry, cntaoa, cntpath, cnthsp, cntftp, cntftt);
        setTimeout(() => {
            this.props.onClick();
        }, 2000); 
    }  

    addFormFields(fmval) {
        if(fmval==1){
            var chktotal=this.state.cntclub;
            var totalsep=chktotal+1;
            this.setState(({
                cntclub:totalsep,  
                clubform: [...this.state.clubform, {  club : "" }]
            }))
        }else if(fmval==2){
            var chktotal=this.state.cntball;
            var totalsep=chktotal+1;
            this.setState(({
                cntball:totalsep,  
                ballform: [...this.state.ballform, {  ball : "" }]
            }))
        }else if(fmval==3){
            var chktotal=this.state.cntrate;
            var totalsep=chktotal+1;
            this.setState(({
                cntrate:totalsep,  
                rateform: [...this.state.rateform, {  rate : "" }]
            }))
        }else if(fmval==4){
            var chktotal=this.state.cntsmash;
            var totalsep=chktotal+1;
            this.setState(({
                cntsmash:totalsep,  
                smashform: [...this.state.smashform, {  smash : "" }]
            }))
        }else if(fmval==5){
            var chktotal=this.state.cntcry;
            var totalsep=chktotal+1;
            this.setState(({
                cntcry:totalsep,  
                carryform: [...this.state.carryform, {  carry : "" }]
            }))
        }else if(fmval==6){
            var chktotal=this.state.cntaoa;
            var totalsep=chktotal+1;
            this.setState(({
                cntaoa:totalsep,  
                aoaform: [...this.state.aoaform, {  dynamic : "" }]
            }))
        }else if(fmval==7){
            var chktotal=this.state.cntpath;
            var totalsep=chktotal+1;
            this.setState(({
                cntpath:totalsep,  
                pathform: [...this.state.pathform, {  launch : "" }]
            }))
        }else if(fmval==8){
            var chktotal=this.state.cnthsp;
            var totalsep=chktotal+1;
            this.setState(({
                cnthsp:totalsep,  
                hspform: [...this.state.hspform, {  landing : "" }]
            }))
        }else if(fmval==9){
            var chktotal=this.state.cntftp;
            var totalsep=chktotal+1;
            this.setState(({
                cntftp:totalsep,  
                ftpform: [...this.state.ftpform, {  landing : "" }]
            }))
        }else if(fmval==10){
            var chktotal=this.state.cntftt;
            var totalsep=chktotal+1;
            this.setState(({
                cntftt:totalsep,  
                fttform: [...this.state.fttform, {  landing : "" }]
            }))
        }
    }

    removeFormFields(i,fmval){
        if(fmval==1){
            let clubform = this.state.clubform;
            var chktotal=this.state.cntclub;
            var totalsep=chktotal-1;
            clubform.splice(i, 1);
            this.setState({ clubform, cntclub:totalsep });
        }else  if(fmval==2){
            let ballform = this.state.ballform;
            var chktotal=this.state.cntball;
            var totalsep=chktotal-1;
            ballform.splice(i, 1);
            this.setState({ ballform, cntball:totalsep });
        }else  if(fmval==3){
            let rateform = this.state.rateform;
            var chktotal=this.state.cntrate;
            var totalsep=chktotal-1;
            rateform.splice(i, 1);
            this.setState({ rateform, cntrate:totalsep });
        }else  if(fmval==4){
            let smashform = this.state.smashform;
            var chktotal=this.state.cntsmash;
            var totalsep=chktotal-1;
            smashform.splice(i, 1);
            this.setState({ smashform, cntsmash:totalsep });
        }else  if(fmval==5){
            let carryform = this.state.carryform;
            var chktotal=this.state.cntcry;
            var totalsep=chktotal-1;
            carryform.splice(i, 1);
            this.setState({ carryform, cntcry:totalsep });
        }else  if(fmval==6){
            let aoaform = this.state.aoaform;
            var chktotal=this.state.cntaoa;
            var totalsep=chktotal-1;
            aoaform.splice(i, 1);
            this.setState({ aoaform, cntaoa:totalsep });
        }else  if(fmval==7){
            let pathform = this.state.pathform;
            var chktotal=this.state.cntpath;
            var totalsep=chktotal-1;
            pathform.splice(i, 1);
            this.setState({ pathform, cntpath:totalsep });
        }else  if(fmval==8){
            let hspform = this.state.hspform;
            var chktotal=this.state.cnthsp;
            var totalsep=chktotal-1;
            hspform.splice(i, 1);
            this.setState({ hspform, cnthsp:totalsep });
        }else  if(fmval==9){
            let ftpform = this.state.ftpform;
            var chktotal=this.state.cntftp;
            var totalsep=chktotal-1;
            ftpform.splice(i, 1);
            this.setState({ ftpform, cntftp:totalsep });
        }else  if(fmval==10){
            let fttform = this.state.fttform;
            var chktotal=this.state.cntftt;
            var totalsep=chktotal-1;
            fttform.splice(i, 1);
            this.setState({ fttform, cntftt:totalsep });
        }  
      
    }

    handleChange(i, e, fmval) {
        const re = /^[0-9!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]*$/;
        if(fmval==1){
            let clubform = this.state.clubform;       
            clubform[i][e.target.name] = e.target.value;   
            if (e.target.value === "" || re.test(e.target.value)) {
                this.setState({ clubform });
            }     
            
        }else if(fmval==2){
            let ballform = this.state.ballform;       
            ballform[i][e.target.name] = e.target.value;  
            if (e.target.value === "" || re.test(e.target.value)) {
                this.setState({ ballform });
            }
        }else if(fmval==3){
            let rateform = this.state.rateform;       
            rateform[i][e.target.name] = e.target.value;  
            if (e.target.value === "" || re.test(e.target.value)) {
                this.setState({ rateform });
            }
        }else if(fmval==4){
            let smashform = this.state.smashform;       
            smashform[i][e.target.name] = e.target.value;   
            if (e.target.value === "" || re.test(e.target.value)) {
                this.setState({ smashform });
            }
        }else if(fmval==5){
            let carryform = this.state.carryform;       
            carryform[i][e.target.name] = e.target.value;
            if (e.target.value === "" || re.test(e.target.value)) {
                this.setState({ carryform });
            }
        }else if(fmval==6){
            let aoaform = this.state.aoaform;       
            aoaform[i][e.target.name] = e.target.value; 
            if (e.target.value === "" || re.test(e.target.value)) {
                this.setState({ aoaform });
            }   
        }else if(fmval==7){
            let pathform = this.state.pathform;       
            pathform[i][e.target.name] = e.target.value; 
            if (e.target.value === "" || re.test(e.target.value)) {
                this.setState({ pathform });
            } 
        }else if(fmval==8){
            let hspform = this.state.hspform;       
            hspform[i][e.target.name] = e.target.value; 
            if (e.target.value === "" || re.test(e.target.value)) {
                this.setState({ hspform });
            }        
        }else if(fmval==9){
            let ftpform = this.state.ftpform;       
            ftpform[i][e.target.name] = e.target.value;  
            if (e.target.value === "" || re.test(e.target.value)) {
                this.setState({ ftpform });
            }
        }else if(fmval==10){
            let fttform = this.state.fttform;       
            fttform[i][e.target.name] = e.target.value;   
            if (e.target.value === "" || re.test(e.target.value)) {
                this.setState({ fttform });
            }  
        }              
    }


render() {

    const { studentlists, particularfsirons, loading} = this.props;   
    const allstudent=studentlists.map((stdval) => {  
        return {
           label: stdval.student,  
           value: stdval.uudID
        }
    });

    const styles = {
        adbtn: {
            cursor: "pointer",
            color:"#7070f0",
            marginRight: "40px"
        },
        rembtn:{
            position:"relative",
            float: "right",
            marginTop: "-25px",
            marginRight: "20px",
            cursor: "pointer"
        }
    };

      return(
        <div>
             <div className="col-md-12">
                <form autoComplete="off" id="editform" onSubmit={(e)=>this.editHandleSubmit(e)}>
                     <div className="row">
                        <div className="col-sm-12 col-md-8" style={{margin:"0 auto"}}>
                            <RctCollapsibleCard heading="Edit FS IRONS">
                                    <div className="row"> 
                                        <div className="col-sm-12 col-md-7"> 
                                                <Label for="Select">Student *</Label>
                                                <FormGroup>    
                                                    <Label for="Select">Student *</Label>                                                
                                                    <Selectsearch id="student" name="student" options={allstudent} rules={{ required: 'Please select an student'}} value={allstudent.find(obj => obj.value === this.state.student)} onChange={this.selstudent} required/>
                                                </FormGroup>
                                        </div> 
                                        
                                        <div className="col-sm-12 col-md-7">
                                            <FormGroup>
                                                <Label for="date">Date *</Label>
                                                <DatePicker className="form-control" id="seldate"  name="seldate" autoComplete="off" required
                                                        selected={this.state.seldate}
                                                        onChange={this.selectdate}
                                                        dateFormat='yyyy-MM-dd'
                                                        peekNextMonth
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode="select"
                                                    /> 
                                            </FormGroup>                                          
                                        </div> 
                                         
                                        <div className="col-sm-12 col-md-6"> 
                                                <Label for="country">CLUB SPEED (mph)<span className='float-right' style={styles.adbtn} onClick={() => this.addFormFields(1)}><i class="zmdi zmdi-plus-circle-o"></i> add</span></Label>
                                            {this.state.clubform.map((element, index) => (  
                                                <FormGroup> 
                                                    <div className='col-md-11'>                                             
                                                    <input type="text" name="club" id={"clubspeed_"+index} value={element.club || ""} className="form-control form-control-alternative" onChange={e => this.handleChange(index, e, 1)}/>
                                                    </div>
                                                    {
                                                        index ? 
                                                        <span className="text-danger" style={styles.rembtn} aria-label="Remove" onClick={() => this.removeFormFields(index,1)}  > <i className="ti-close"></i></span>
                                                            : null
                                                    }                                                
                                                </FormGroup>  
                                            ))}  
                                        </div>
                                        <div className="col-sm-12 col-md-6"> 
                                                <Label for="country">BALL SPEED (mph)<span className='float-right' style={styles.adbtn} onClick={() => this.addFormFields(2)}><i class="zmdi zmdi-plus-circle-o"></i> add</span></Label>
                                            {this.state.ballform.map((element, index) => (  
                                                <FormGroup> 
                                                    <div className='col-md-11'>                                             
                                                    <input type="text" name="ball" id={"ball_"+index} value={element.ball || ""} className="form-control form-control-alternative" onChange={e => this.handleChange(index, e, 2)}/>
                                                    </div>
                                                    {
                                                        index ? 
                                                        <span className="text-danger" style={styles.rembtn} aria-label="Remove" onClick={() => this.removeFormFields(index,2)}  > <i className="ti-close"></i></span>
                                                            : null
                                                    }                                                
                                                </FormGroup>  
                                            ))}  
                                        </div>                                        
                                        <div className="col-sm-12 col-md-6"> 
                                                <Label for="country">SPIN RATE (rpm)<span className='float-right' style={styles.adbtn} onClick={() => this.addFormFields(3)}><i class="zmdi zmdi-plus-circle-o"></i> add</span></Label>
                                            {this.state.rateform.map((element, index) => (  
                                                <FormGroup> 
                                                    <div className='col-md-11'>                                             
                                                    <input type="text" name="rate" id={"rate_"+index} value={element.rate || ""} className="form-control form-control-alternative" onChange={e => this.handleChange(index, e, 3)}/>
                                                    </div>
                                                    {
                                                        index ? 
                                                        <span className="text-danger" style={styles.rembtn} aria-label="Remove" onClick={() => this.removeFormFields(index,3)}  > <i className="ti-close"></i></span>
                                                            : null
                                                    }                                                
                                                </FormGroup>  
                                            ))}  
                                        </div>
                                        <div className="col-sm-12 col-md-6"> 
                                                <Label for="country">SMASH<span className='float-right' style={styles.adbtn} onClick={() => this.addFormFields(4)}><i class="zmdi zmdi-plus-circle-o"></i> add</span></Label>
                                            {this.state.smashform.map((element, index) => (  
                                                <FormGroup> 
                                                    <div className='col-md-11'>                                             
                                                    <input type="text" name="smash" id={"smash_"+index} value={element.smash || ""} className="form-control form-control-alternative" onChange={e => this.handleChange(index, e, 4)}/>
                                                    </div>
                                                    {
                                                        index ? 
                                                        <span className="text-danger" style={styles.rembtn} aria-label="Remove" onClick={() => this.removeFormFields(index,4)}  > <i className="ti-close"></i></span>
                                                            : null
                                                    }                                                
                                                </FormGroup>  
                                            ))}  
                                        </div>
                                        <div className="col-sm-12 col-md-6"> 
                                                <Label for="country">CARRY (yds)<span className='float-right' style={styles.adbtn} onClick={() => this.addFormFields(5)}><i class="zmdi zmdi-plus-circle-o"></i> add</span></Label>
                                            {this.state.carryform.map((element, index) => (  
                                                <FormGroup> 
                                                    <div className='col-md-11'>                                             
                                                    <input type="text" name="carry" id={"carry_"+index} value={element.carry || ""} className="form-control form-control-alternative" onChange={e => this.handleChange(index, e, 5)}/>
                                                    </div>
                                                    {
                                                        index ? 
                                                        <span className="text-danger" style={styles.rembtn} aria-label="Remove" onClick={() => this.removeFormFields(index,5)}  > <i className="ti-close"></i></span>
                                                            : null
                                                    }                                                
                                                </FormGroup>  
                                            ))}  
                                        </div>
                                        <div className="col-sm-12 col-md-6"> 
                                                <Label for="country">AOA (deg)<span className='float-right' style={styles.adbtn} onClick={() => this.addFormFields(6)}><i class="zmdi zmdi-plus-circle-o"></i> add</span></Label>
                                            {this.state.aoaform.map((element, index) => (  
                                                <FormGroup> 
                                                    <div className='col-md-11'>                                             
                                                    <input type="text" name="aoa" id={"aoa_"+index} value={element.aoa || ""} className="form-control form-control-alternative" onChange={e => this.handleChange(index, e, 6)}/>
                                                    </div>
                                                    {
                                                        index ? 
                                                        <span className="text-danger" style={styles.rembtn} aria-label="Remove" onClick={() => this.removeFormFields(index,6)}  > <i className="ti-close"></i></span>
                                                            : null
                                                    }                                                
                                                </FormGroup>  
                                            ))}  
                                        </div>
                                        <div className="col-sm-12 col-md-6"> 
                                                <Label for="country">PATH (deg)<span className='float-right' style={styles.adbtn} onClick={() => this.addFormFields(7)}><i class="zmdi zmdi-plus-circle-o"></i> add</span></Label>
                                            {this.state.pathform.map((element, index) => (  
                                                <FormGroup> 
                                                    <div className='col-md-11'>                                             
                                                    <input type="text" name="path" id={"path_"+index} value={element.path || ""} className="form-control form-control-alternative" onChange={e => this.handleChange(index, e, 7)}/>
                                                    </div>
                                                    {
                                                        index ? 
                                                        <span className="text-danger" style={styles.rembtn} aria-label="Remove" onClick={() => this.removeFormFields(index,7)}  > <i className="ti-close"></i></span>
                                                            : null
                                                    }                                                
                                                </FormGroup>  
                                            ))}  
                                        </div>
                                        <div className="col-sm-12 col-md-6"> 
                                                <Label for="country">HSP (deg)<span className='float-right' style={styles.adbtn} onClick={() => this.addFormFields(8)}><i class="zmdi zmdi-plus-circle-o"></i> add</span></Label>
                                            {this.state.hspform.map((element, index) => (  
                                                <FormGroup> 
                                                    <div className='col-md-11'>                                             
                                                    <input type="text" name="hsp" id={"hsp_"+index} value={element.hsp || ""} className="form-control form-control-alternative" onChange={e => this.handleChange(index, e, 8)}/>
                                                    </div>
                                                    {
                                                        index ? 
                                                        <span className="text-danger" style={styles.rembtn} aria-label="Remove" onClick={() => this.removeFormFields(index,8)}  > <i className="ti-close"></i></span>
                                                            : null
                                                    }                                                
                                                </FormGroup>  
                                            ))}  
                                        </div>
                                        <div className="col-sm-12 col-md-6"> 
                                                <Label for="country">FTP (deg)<span className='float-right' style={styles.adbtn} onClick={() => this.addFormFields(9)}><i class="zmdi zmdi-plus-circle-o"></i> add</span></Label>
                                            {this.state.ftpform.map((element, index) => (  
                                                <FormGroup> 
                                                    <div className='col-md-11'>                                             
                                                    <input type="text" name="ftp" id={"ftp_"+index} value={element.ftp || ""} className="form-control form-control-alternative" onChange={e => this.handleChange(index, e, 9)}/>
                                                    </div>
                                                    {
                                                        index ? 
                                                        <span className="text-danger" style={styles.rembtn} aria-label="Remove" onClick={() => this.removeFormFields(index,9)}  > <i className="ti-close"></i></span>
                                                            : null
                                                    }                                                
                                                </FormGroup>  
                                            ))}  
                                        </div>
                                        <div className="col-sm-12 col-md-6"> 
                                                <Label for="country">FTT (deg)<span className='float-right' style={styles.adbtn} onClick={() => this.addFormFields(10)}><i class="zmdi zmdi-plus-circle-o"></i> add</span></Label>
                                            {this.state.fttform.map((element, index) => (  
                                                <FormGroup> 
                                                    <div className='col-md-11'>                                             
                                                    <input type="text" name="ftt" id={"ftt_"+index} value={element.ftt || ""} className="form-control form-control-alternative" onChange={e => this.handleChange(index, e, 10)}/>
                                                    </div>
                                                    {
                                                        index ? 
                                                        <span className="text-danger" style={styles.rembtn} aria-label="Remove" onClick={() => this.removeFormFields(index,10)}  > <i className="ti-close"></i></span>
                                                            : null
                                                    }                                                
                                                </FormGroup>  
                                            ))}  
                                        </div>                                         
                                        <div className="col-sm-12 col-md-12">   
                                            <FormGroup>
                                                <Label for="country">INFERENCE</Label>
                                                <textarea rows="2" type="text" name="inference_1" id="inference_1" className="form-control form-control-alternative" defaultValue={particularfsirons.gfs_inference}></textarea>
                                            </FormGroup>  
                                        </div>
                                        <div className="col-sm-12 col-md-12">   
                                            <FormGroup>
                                                <Label for="country">Notes</Label>
                                                <textarea rows="2" type="text" name="notes_1" id="notes_1" className="form-control form-control-alternative" defaultValue={particularfsirons.gfs_notes}></textarea>
                                            </FormGroup>  
                                        </div>

                                       <div className="col-md-12">
                                        <div className="form-group"> 
                                            <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Submit" />  
                                            <button type="button" className="mr-3 mb-3 btn btn-outline-warning" onClick={this.props.onClick} >Back</button>   
                                        </div>
                                       </div>
                                    </div>    
                            </RctCollapsibleCard>
                         </div>   
                        </div>
                      </form>
                       </div>
                </div>
              
    )
   
}
 
}

const mapStateToProps = ({ mostlyused, fsirons}) => {
    const { studentlists, loading } = mostlyused;
    const { particularfsirons } = fsirons;
    return { studentlists, particularfsirons, loading };
   
}


export default connect(mapStateToProps, {
    allStudents,
    editFSIrons,
})(EditItems);
